import React from 'react';
import { Button, FlexBox } from '@eltoro-ui/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { GenerationTypeEnum } from 'enums';

type QuestionBlockProps = {
  userPhoto: string | null;
  userName: string;
  promptData: string;
  hasErr?: boolean;
  onRetry: VoidFunction;
  type: GenerationTypeEnum | null;
};
const QuestionBlock = ({
  userPhoto,
  userName,
  promptData,
  hasErr,
  onRetry,
  type,
}: QuestionBlockProps) => {
  const getInitials = (name: string) => {
    return name.match(/\b(\w)/g)?.slice(0, 3) || '';
  };

  return (
    <FlexBox alignSelf="flex-end" gap="8px">
      <FlexBox flexDirection="column" alignItems="flex-end">
        <FlexBox gap="12px">
          <FlexBox
            flexDirection="column"
            alignItems="center"
            justifyContent="flex-end"
            UNSAFE_className="msg-container"
          >
            <p className="message">
              {type === GenerationTypeEnum.SELECTED
                ? '👇 Make more changes to the banner below.'
                : promptData}
            </p>
          </FlexBox>
        </FlexBox>
        {hasErr && (
          <FlexBox alignItems="center" gap="8px">
            <FontAwesomeIcon
              icon={faExclamationCircle}
              style={{ fontSize: '16px' }}
              color="#B0B0B0"
            />
            <span className="fail-msg">An error occurred while responding.</span>
            <Button kind="link" UNSAFE_className="retry" onClick={onRetry}>
              Resend the message
            </Button>
          </FlexBox>
        )}
      </FlexBox>
      <FlexBox justifyContent="center" alignItems="center" UNSAFE_className="user-img">
        {userPhoto ? (
          <img src={userPhoto} alt="logo" className="bw-logo" />
        ) : (
          <div className="user-initials">{getInitials(userName)}</div>
        )}
      </FlexBox>
    </FlexBox>
  );
};

export default QuestionBlock;
